import {request} from './client';

interface RawSessionResponse {
  data: {
    token: string;
    expires_at: string;
  };
}

export interface ViewerSession {
  token: string;
  expiresAt: string;
}

// The response never carries an organization identifier — that arrives with
// the entity token (tokens/verify-confirm); callers keep the one they minted
// with.
export async function mintViewerSession(
  organizationIdentifier: string,
  refreshToken: string,
): Promise<ViewerSession> {
  const raw = await request<RawSessionResponse>(
    organizationIdentifier,
    '/sharing/session',
    {
      method: 'POST',
      body: {organization_identifier: organizationIdentifier},
      headers: {Authorization: `Bearer ${refreshToken}`},
    },
  );

  return {
    token: raw.data.token,
    expiresAt: raw.data.expires_at,
  };
}
